import QRCode from 'qrcodejs2';
import { alertController, IonicSafeString, toastController } from '@ionic/vue';

const HasCouponSharing = {
  data() {
    return {
      // List of "fresh" offline-shareable coupons (behind the `locatShareIds` localStorage key)
      shareableCoupons: [],
    };
  },

  methods: {
    refreshShareableCoupons() {
      this.shareableCoupons =
        JSON.parse(localStorage.getItem('locatShareIds')) || [];
    },

    /** Show the build link in a modal, from share_id */
    async presentShare(coupon) {
      if (!coupon.share_id) {
        console.error('Coupon has no share_id:', coupon);
        return;
      }

      let link =
        process.env.VUE_APP_API_URL.replace('pwa-api', 'go/bl/') +
        coupon.share_id;

      let message = new IonicSafeString(`
        <div style='word-break:break-all;'>
          LV n°${coupon.name}<br>
          <br>
          <div id="coupon-qr" class="coupon-qr"></div>
          <br>
          <a href='${link}' style="color: #333;" target='_blank'>${link}</a>
        </div>`);

      const alert = await alertController.create({
        header: 'Lien de partage',
        message,
        buttons: [
          {
            text: 'Copier le lien',
            handler: () => {
              this.copy(link);

              // prevent alert closing
              return false;
            },
          },
          {
            text: 'Fermer',
            role: 'cancel',
          },
        ],
        cssClass: 'share-link-alert',
      });
      await alert.present();

      // Generate QR code
      new QRCode(document.getElementById('coupon-qr'), {
        text: link,
        width: 220,
        height: 220,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H,
      });
    },

    /**
     * Copy given link to clipboard
     */
    async copy(link) {
      if (!link) return;

      const toastData = {
        message: 'Lien copié dans le presse-papiers',
        duration: 1500,
        position: 'bottom',
      };

      try {
        await navigator.clipboard.writeText(link);
      } catch (err) {
        toastData.color = 'danger';
        toastData.message = 'Erreur lors de la copie du lien';
      } finally {
        const toast = await toastController.create(toastData);
        await toast.present();
      }
    },
  },

  computed: {
    isShareable() {
      // Ensure computed works with several namings
      let rentalCoupon = null;
      if (this.rentalCoupon && this.rentalCoupon.name) {
        rentalCoupon = this.rentalCoupon;
      } else if (this.oldRentalCoupon && this.oldRentalCoupon.name) {
        rentalCoupon = this.oldRentalCoupon;
      }

      // if no coupon or coupon is reservation, not shareable
      if (!rentalCoupon) return false;
      if (rentalCoupon.reservation_id) return false;

      return !!rentalCoupon.share_id;
    },
  },
};

export default HasCouponSharing;
